import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Box, type SxProps, type Theme } from "@mui/material";
import type { FC, MouseEvent, ReactNode } from "react";
import type { SortOrder } from "../../../../utils/multiColumnSorting";
import { gridColumnHeadersStyle } from "../utils";

export type SortableHeaderButtonProps = {
	onSortClick?: (e: MouseEvent) => void;
	sortOrder?: SortOrder;
};

type Props = SortableHeaderButtonProps & {
	label: ReactNode;
	injectStyle: boolean;
};

export const SortableHeaderButton: FC<Props> = ({ onSortClick, sortOrder, label, injectStyle }) => {
	//TODO add disable for the sort
	return (
		<Box
			sx={
				injectStyle
					? ([
							gridColumnHeadersStyle,
							(theme: Theme) => ({
								cursor: "pointer",
								display: "flex",
								gap: 1,
								":hover": { backgroundColor: theme.palette.primary.main },
							}),
						] as SxProps<Theme>)
					: { display: "flex", gap: 1, alignItems: "center" }
			}
			onClick={onSortClick}
		>
			{label}
			{sortOrder === "asc" && <ArrowUpwardIcon fontSize={"small"} />}
			{sortOrder === "desc" && <ArrowDownwardIcon fontSize={"small"} />}
		</Box>
	);
};
